import { ProposalList } from './pages/proposalsList';
import { ProposalsForm } from './pages/proposalsForm';
import ProposalsCheckCpf from './pages/proposalCheckCpf';
import { ProposalsDatatableSituation } from './pages/proposalsDatatableSituation';

export const ProposalsRoutes = [
  {
    path: '/propostas/nova',
    component: ProposalsCheckCpf,
  },
  {
    path: '/propostas/list/:id',
    component: ProposalList,
  },
  {
    path: '/propostas/novo',
    component: ProposalsForm,
  },
  {
    path: '/propostas/editar/:proposalId',
    component: ProposalsForm,
  },
  {
    path: '/propostas/view/:proposalId',
    component: ProposalsForm,
  },
  {
    path: '/propostas/:filter',
    component: ProposalsDatatableSituation,
  },
];
